import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Alert,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; 
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { allowedUsers } from "./constants"; 

export default function AttendanceDropdown() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [accessMsg, setAccessMsg] = useState({ open: false, text: "", sev: "info" });
  const navigate = useNavigate();

  const handleClick = (event) => setAnchorEl(event.currentTarget);
    
//   const handleClick = (event) => {
//   if (!showAttendanceDropdown) {
//     setAccessMsg({ open: true, text: "You are not admin.", sev: "warning" });
//     return;
//   }
//   setAccessMsg({ open: true, text: "You are admin.", sev: "success" });
//   setAnchorEl(event.currentTarget);
// };

  const handleClose = (path) => {
    setAnchorEl(null);
    if (path) navigate(path);
  };

    const username = localStorage.getItem("saved_username") || "";
    const showAttendanceDropdown = allowedUsers.includes(username);
  return (
    <>
    
      <Button
        color="inherit"
        startIcon={<EventIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
        >
        Attendance
      </Button>

      <Snackbar
        open={accessMsg.open}
        autoHideDuration={3000}
        onClose={() => setAccessMsg((m) => ({ ...m, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setAccessMsg((m) => ({ ...m, open: false }))}
          severity={accessMsg.sev}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {accessMsg.text}
        </Alert>
      </Snackbar>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {/* <MenuItem onClick={() => handleClose("/home/calendar/")}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>My Attendance</ListItemText>
        </MenuItem> */}

        
{/* {showAttendanceDropdown && 
<> */}
        {/* {false && (      related to the admin (constants) */}
  <>
    {/* <MenuItem onClick={() => handleClose("/home/calendar/all")}>
      <ListItemIcon>
        <GroupsIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText> Attendance Report </ListItemText>
    </MenuItem> */}

    <MenuItem onClick={() => handleClose("/home/calendar/new")}>
      <ListItemIcon>
        <GroupsIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>All Attendances </ListItemText>
    </MenuItem>
  </>
 {/* )} */}
       
        <MenuItem onClick={() => handleClose("/home/calendar/approve")}>
          <ListItemIcon>
            <CheckCircleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Approve Leave Request</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => handleClose("/home/calendar/approve-visits")}>
          <ListItemIcon>
            <CheckCircleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Approve Visit Request</ListItemText>
        </MenuItem>
        
        {/* </>
         */}
{/* } */}
      </Menu>
    </>
  );
}
